import Panel, { PANEL_WIDTH } from '@cartwhl/ui/layout/Panel';

import type { CanvasLayoutRegisteredSidePanel } from './canvasLayoutContext';

interface CanvasLayoutDesktopPanelProps {
  sidePanel: CanvasLayoutRegisteredSidePanel | null;
  isVisible: boolean;
  onContentContainerChange: (node: HTMLDivElement | null) => void;
}

export default function CanvasLayoutDesktopPanel({
  sidePanel,
  isVisible,
  onContentContainerChange,
}: CanvasLayoutDesktopPanelProps) {
  return (
    <div
      className="h-full shrink-0 transition-[width] duration-200"
      style={{ width: isVisible ? PANEL_WIDTH : 0 }}
    >
      {sidePanel !== null && isVisible && (
        <Panel
          key={sidePanel.id}
          title={sidePanel.title}
          closePanel={sidePanel.closePanel}
          loading={sidePanel.loading}
          statusText={sidePanel.statusText}
          additionalButtons={sidePanel.additionalButtons}
          className={sidePanel.className}
        >
          <div ref={onContentContainerChange} className="contents" />
        </Panel>
      )}
    </div>
  );
}
